var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.386 0A4.373 4.373 0 0 0 .004 4.382v15.236A4.373 4.373 0 0 0 4.386 24h8.258v-9.383h-2.481V11.24h2.48V8.354c0-2.268 1.467-4.35 4.843-4.35 1.368 0 2.379.132 2.379.132l-.08 3.154s-1.03-.01-2.156-.01c-1.218 0-1.413.561-1.413 1.493v2.466h3.666l-.16 3.378h-3.506V24h3.406a4.373 4.373 0 0 0 4.382-4.382V4.382A4.373 4.373 0 0 0 19.622 0H4.386Z","fill":"#DEDEDE"}));
}

Facebook.defaultProps = {"width":"25","height":"24","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
